export const buildSelectedFiltersDisplay = (translate) => {

  return {
    direction: translate("filters-display.Direction"),
    ReconciliationStreamTag: translate("filters-display.StreamName"),
    TotalInTransitRecords: translate("filters-display.InTransitRecordID"),
    TotalExceptionRecords: translate("filters-display.ExceptionRecordID"),
    TotalMatchingRecords: translate("filters-display.MatchingRecordID"),
    TotalReconciledRecords: translate("filters-display.ReconciledRecordID"),
    NextReconciliationRun: translate("filters-display.NextRun"),
    StartDate: translate("filters-display.StartDate"),
    EndDate: translate("filters-display.EndDate"),
    ScheduleDate: translate("filters-display.ScheduleDate"),
    contains: translate("filters-display.Contains"),
    startWith: translate("filters-display.StartsWith"),
    endWith: translate("filters-display.EndsWith"),
    IsScheduled: translate("filters-display.Scheduled"),
    ReconciliationRunStatusTag: translate(
      "reconciliation-runs.filters.reconciliationStreamStatus"
    ),
    Trigger: translate("filters-display.Trigger"),
    RunId: translate("filters-display.RunID"),
    BusinessDay: translate("filters-display.BusinessDay"),
  };
};
